// extracted by mini-css-extract-plugin
export default {"title":"despesa_title__h03Mj","input":"despesa_input__TR-on","form":"despesa_form__0vY3h","campo":"despesa_campo__pAF9m","label":"despesa_label__bO7QR"};